
import React,{useEffect} from "react";
import checkicon from '../../assets/images/checkicon.png';
import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";
import { useHistory, Link, useLocation } from "react-router-dom";
const Thankyou = () => {
    const history = useHistory();
    useEffect(()=>{
        if (!localStorage.getItem("token")) {
            history.push("/login");
        }
    },[])
           
    useEffect(() => {
       
 // Add event listener for popstate to detect when the user presses the back button
 const handlePopState = (event) => {
        
  history.push("/")
    event.preventDefault();
    console.log("Browser back button pressed.");
  
};

// Initially pushState to allow popstate to fire
window.history.pushState({}, document.title, window.location.href);

// Add popstate listener
window.addEventListener("popstate", handlePopState);

return () => {
  // Cleanup event listener when component unmounts
  window.removeEventListener("popstate", handlePopState);
};

      }, []);
    return (
        <main>
            <Header />
            <div className="thankyou-section">
                <div className="d-flex justify-content-center align-items-center">
                    <div>
                        <div className="mb-4 text-center">
                            <img src={checkicon} className="check" />
                        </div>
                        <div className="text-center">
                            <h1>Thank You !</h1>
                            <p className="text-style-one">Thank you for submitting the quiz!</p>
                            <p className="text-style-two">Your Responses have been successfully recorded if there are any further instructions or feedback,we will notify you shortly</p>
                            <Link className="btn" to="/">Back Home</Link>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </main>
    );
};

export default Thankyou;
